import { render, staticRenderFns } from "./ValveUpInstructions2.vue?vue&type=template&id=09763ffe&"
import script from "./ValveUpInstructions2.vue?vue&type=script&lang=js&"
export * from "./ValveUpInstructions2.vue?vue&type=script&lang=js&"
import style0 from "./ValveUpInstructions2.vue?vue&type=style&index=0&id=09763ffe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports